import React, { useEffect } from "react";
import { TextInput } from "react-materialize";
import { useAlluser } from "context/AlluserContext";

export default function FilterSearch() {
  const { filters, storeFilters } = useAlluser();
  const filterName = "search";

  let handleEvents = {
    OnChange: function (evt) {
      if (evt.target.value.length >= 3 || evt.target.value.length === 0) {
        // console.log(evt.target.value);
        storeFilters({ ...filters, search: evt.target.value });
      }
    },
  };

  useEffect(() => {}, []);

  return (
    <div
      id={"filter-" + filterName}
      key={"filter-" + filterName + "-" + filters.key_form}
      className="filter-input-field"
      style={{ marginTop: "15px" }}
    >
      <TextInput
        //icon={<Icon>search</Icon>}
        placeholder=""
        id="filter-inp-search"
        name="search"
        label="IDU or Name or Email Search"
        onChange={handleEvents.OnChange}
      />
    </div>
  );
}
